/* /mtg-budget-swaps — price a pasted list (free), then ask the suggestBudgetSwaps callable for cheaper
 * same-role, in-identity cards (free account). Savings count every copy. Pick a swap per card, then copy
 * the budget list, save it to your decks, or buy it on TCGplayer in one go.
 */
import "../lib/site.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";
import "../lib/fb-lazy.js";
import "../tools/panel.js";

(function () {
  "use strict";

  var KD = window.KD, T = KD.tools, esc = KD.esc;
  var out = KD.$("[data-out]");
  if (!out) return;
  var emptyHTML = out.innerHTML;
  var NAME = { W: "White", U: "Blue", B: "Black", R: "Red", G: "Green" };
  var EXAMPLE = ["Commander", "1 Atraxa, Praetors' Voice", "", "Deck", "1 Mana Crypt", "1 Smothering Tithe", "1 Cyclonic Rift", "1 Rhystic Study", "1 Doubling Season", "1 Chrome Mox",
    "1 Mana Vault", "1 Vampiric Tutor", "1 Sol Ring", "1 Cultivate", "1 Farseek", "1 Swords to Plowshares", "1 Counterspell", "1 Wrath of God", "1 Phyrexian Arena",
    "1 Command Tower", "1 Breeding Pool", "1 Watery Grave", "1 Hallowed Fountain", "1 Overgrown Tomb", "9 Forest", "7 Island", "7 Swamp", "7 Plains"].join("\n");
  var model = null, parsed = null, swaps = null, pick = {}, top = [];
  var autorun = false;
  try { autorun = localStorage.getItem("kraken_pending_swaps_autorun") === "1"; localStorage.removeItem("kraken_pending_swaps_autorun"); } catch (e) { /* ignore */ }

  var panel = KD.toolPanel({ key: "kraken_pending_swaps", example: EXAMPLE, run: price, clear: function () { out.innerHTML = emptyHTML; model = null; } });
  function money(n) { return "$" + (Number(n) || 0).toFixed(2); }

  async function price(text, reason) {
    parsed = T.parseDecklist(text);
    if (!parsed.rows.length) { panel.status("No card lines found. Paste one card per line, like “1 Sol Ring”."); return; }
    panel.status("Pricing " + parsed.rows.length + " cards on Scryfall…", true);
    var res;
    try { res = await T.resolveCards(parsed.rows, function (d, t) { panel.status("Pricing cards… " + d + " of " + t, true); }); }
    catch (e) { panel.status("Scryfall didn't answer. Try again in a moment."); return; }
    if (!res.matched.length) {
      panel.status("");
      out.innerHTML = '<div class="tool__empty"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg><h2>No cards matched</h2><p>Check the spelling, one card per line.</p></div>' + KD.unmatchedHTML(res.unmatched, "priced");
      return;
    }
    if (res.matched.some(function (x) { return T.priceOf(x.card) === null; })) {
      panel.status("Pricing new printings at their cheapest copy…", true);
      await T.repriceUnpriced(res.matched);
    }
    panel.status("");
    model = T.buildModel(res.matched);
    swaps = null; pick = {};
    top = model.swappable.slice(0, 15);
    paint(res.unmatched);
    KD.ga("swaps_price", { reason: reason, cards: model.totalCards, total: Math.round(model.totalPrice) });
    if (reason !== "handoff" || KD.mobile()) out.scrollIntoView({ behavior: KD.reduce ? "auto" : "smooth", block: "start" });
    if (reason === "handoff" && autorun && KD.signedIn && top.length) { autorun = false; findSwaps(); }
  }

  function paint(unmatched) {
    var m = model, ci = m.deckColorIdentity;
    var maxLine = top.length ? top[0].price * top[0].qty : 1;
    out.innerHTML =
      '<div class="tsum"><p class="depth-tag">' + (m.format === "commander" ? "Commander deck" : m.totalCards + "-card deck") + "</p><h2>" + money(m.totalPrice) + '</h2><p class="hint">TCGplayer market total for ' + m.priced + " of " + m.totalCards + " cards" + (m.unpriced ? " (" + m.unpriced + " had no price)" : "") + "</p></div>" +
      '<div class="tstats">' +
        "<div><b>" + m.totalCards + "</b><span>Cards</span></div>" +
        "<div><b>" + m.swappable.length + "</b><span>Cards at $2+</span></div>" +
        "<div><b>" + (m.totalPrice ? Math.round(top.reduce(function (s, r) { return s + r.price * r.qty; }, 0) / m.totalPrice * 100) : 0) + "%</b><span>Of the cost in the top " + top.length + "</span></div>" +
        '<div><b class="pips">' + (ci.length ? KD.colorPips(ci) : KD.mana("{C}")) + "</b><span>" + (m.commanders.length ? "Commander colors" : "Colors") + "</span></div>" +
      "</div>" +
      (m.commanders.length ? '<p class="tcmd"><svg class="i" aria-hidden="true"><use href="#i-crown"/></svg><span><b>' + esc(m.commanders.join(" + ")) + "</b> is never swapped: every suggestion stays in " + esc(ci.map(function (c) { return NAME[c]; }).join(", ") || "colorless") + ".</span></p>" : "") +
      '<section class="panel panel--pad tprices"><div class="row row--between"><h3 class="label">Where the money goes</h3><span class="hint">each · all copies</span></div>' +
      (top.length ? top.map(function (r, i) {
        return '<div class="tprice"><button type="button" class="tprice__name" data-card="' + esc(r.name) + '">' + (r.qty > 1 ? '<span class="tprice__q">' + r.qty + "×</span>" : "") + "<span>" + esc(r.name) + '</span></button><span class="badge">' + esc(r.role) + "</span>" +
          '<span class="tprice__each">' + money(r.price) + '</span><span class="tprice__line">' + money(r.price * r.qty) + '</span><i class="tprice__bar" style="width:' + Math.max(2, Math.round(r.price * r.qty / maxLine * 100)) + '%"></i></div>';
      }).join("") : '<p class="hint">Nothing here costs $2 or more. This is already a budget deck.</p>') + "</section>" +
      (top.length ? '<section class="panel panel--pad tswap" data-swapbox>' + swapBoxHTML() + "</section>" : "") +
      '<div class="tactions"><button class="btn btn--ghost" type="button" data-analyze><svg class="i" aria-hidden="true"><use href="#i-chart"/></svg><span>Analyze this deck</span></button>' +
        '<button class="btn btn--ghost" type="button" data-odds><svg class="i" aria-hidden="true"><use href="#i-dice"/></svg><span>Test opening hands</span></button></div>' +
      KD.unmatchedHTML(unmatched, "priced");
  }

  function swapBoxHTML() {
    if (!swaps) {
      return '<p class="depth-tag">Cheaper swaps</p><h3>Keep the plan, cut the cost</h3><p>The AI suggests cheaper cards for the ' + top.length + " priciest ones: the same job, in your colors, not already in your deck, and each checked on Scryfall to really be cheaper.</p>" +
        (KD.signedIn ? '<button class="btn btn--lure" type="button" data-find><svg class="i" aria-hidden="true"><use href="#i-sparkle"/></svg><span>Find cheaper swaps</span></button>'
          : '<a class="btn btn--lure" href="https://krakenthemeta.com/sign-in" data-unlock><svg class="i" aria-hidden="true"><use href="#i-sparkle"/></svg><span>Create a free account to find swaps</span></a><p class="hint">Pricing stays free with no login. Your list is saved, and you come straight back to your swaps.</p>');
    }
    if (!swaps.swaps || !swaps.swaps.length) return '<p class="depth-tag">Cheaper swaps</p><h3>No cheaper swaps found</h3><p>' + esc(swaps.message || "These cards may already be the efficient picks.") + "</p>";
    var qty = {};
    model.rows.forEach(function (r) { qty[r.lc] = r.qty; });
    var saved = T.totalSavings(swaps.swaps.map(function (sw) { var s = chosen(sw); return { original: sw.original, bestSaved: s ? s.saved : 0 }; }), model.rows);
    return '<div class="tswap__head"><div><p class="depth-tag">Cheaper swaps</p><h3>Save <em>' + money(saved) + "</em></h3><p class=\"hint\">with the swaps picked below, across every copy in your deck</p></div></div>" +
      swaps.swaps.map(function (sw, i) {
        var q = qty[String(sw.original).toLowerCase()] || 1;
        return '<div class="tswap__row"><div class="tswap__orig"><button type="button" data-card="' + esc(sw.original) + '">' + (q > 1 ? q + "× " : "") + esc(sw.original) + "</button><span>" + money(sw.originalPrice) + (q > 1 ? " each" : "") + "</span></div>" +
          '<div class="tswap__opts" role="radiogroup" aria-label="Swap for ' + esc(sw.original) + '">' + (sw.suggestions || []).map(function (s, j) {
            var on = (pick[i] == null ? 0 : pick[i]) === j;
            return '<label class="tswap__opt' + (on ? " is-on" : "") + '"><input type="radio" name="sw' + i + '" value="' + j + '"' + (on ? " checked" : "") + ' data-pick="' + i + '">' +
              '<span class="tswap__name"><button type="button" data-card="' + esc(s.name) + '">' + esc(s.name) + "</button></span><span class=\"tswap__price\">" + money(s.price) + '</span><span class="tswap__save">save ' + money(s.saved * q) + "</span></label>";
          }).join("") + '<label class="tswap__opt tswap__keep' + (pick[i] === -1 ? " is-on" : "") + '"><input type="radio" name="sw' + i + '" value="-1"' + (pick[i] === -1 ? " checked" : "") + ' data-pick="' + i + '"><span>Keep ' + esc(sw.original) + "</span></label></div></div>";
      }).join("") +
      '<div class="tswap__go"><button class="btn btn--lure" type="button" data-copy-budget><svg class="i" aria-hidden="true"><use href="#i-copy"/></svg><span>Copy the budget list</span></button>' +
      '<button class="btn btn--ghost" type="button" data-save-budget><svg class="i" aria-hidden="true"><use href="#i-layers"/></svg><span>Save to my decks</span></button>' +
      '<a class="btn btn--ghost" href="#" target="_blank" rel="nofollow sponsored noopener" data-buy-budget><svg class="i" aria-hidden="true"><use href="#i-cart"/></svg><span>Buy the budget list</span></a></div>' +
      '<p class="hint">Suggestions are AI picks, each checked on Scryfall to be a real card in your colors and cheaper than the one it replaces. Prices change daily; check a swap fits before you buy.</p>';
  }
  function chosen(sw) { var i = swaps.swaps.indexOf(sw), j = pick[i] == null ? 0 : pick[i]; return j >= 0 ? (sw.suggestions || [])[j] : null; }
  function repaintSwaps() { var box = KD.$("[data-swapbox]", out); if (box) box.innerHTML = swapBoxHTML(); }

  // the pasted list with the picked swaps applied (quantities, commander, every other line kept)
  function budgetRows() {
    var repl = {};
    (swaps && swaps.swaps || []).forEach(function (sw) { var s = chosen(sw); if (s) repl[String(sw.original).toLowerCase()] = s.name; });
    var byName = {};
    model.rows.forEach(function (r) { byName[r.lc] = r; });
    return parsed.rows.map(function (r) {
      var matched = model.rows.find(function (x) { return x.lc === r.name.toLowerCase() || x.lc.split(" // ")[0] === r.name.toLowerCase(); });
      var key = matched ? matched.lc : r.name.toLowerCase();
      return { name: repl[key] || (matched ? matched.name : r.name), quantity: r.quantity, commander: r.commander };
    });
  }
  // T.listText writes the Commander section itself (2026-10-03)
  function budgetText() { return T.listText(budgetRows()); }

  async function findSwaps() {
    var box = KD.$("[data-swapbox]", out), btn = KD.$("[data-find]", out);
    if (!box || !top.length) return;
    if (btn) { btn.classList.add("is-busy"); btn.innerHTML = '<span class="spin" aria-hidden="true"></span><span>Finding cheaper swaps…</span>'; }
    KD.ga("swaps_find", { cards: top.length });
    try {
      await KD.firebase.load(["functions"]);
      var user = await KD.firebase.user();
      if (!user) { panel.stashForSignIn("/mtg-budget-swaps", { kraken_pending_swaps_autorun: "1" }); location.href = "https://krakenthemeta.com/sign-in"; return; }
      var fn = firebase.functions().httpsCallable("suggestBudgetSwaps");
      var resp = await fn({
        flagged: top.map(function (r) { return { name: r.name, role: r.role }; }),
        deckColorIdentity: model.deckColorIdentity,
        commanderName: model.commanders[0] || null,
        format: model.format,
        existingNames: model.existingNames
      });
      swaps = resp.data || { swaps: [] };
      pick = {};
      repaintSwaps();
      KD.ga("swaps_found", { swaps: (swaps.swaps || []).length });
    } catch (e) {
      console.error("suggestBudgetSwaps", e);
      box.innerHTML = swapBoxHTML() + '<p class="oresult__err"><svg class="i" aria-hidden="true"><use href="#i-alert"/></svg>' + esc((e && e.message) || "Couldn't find swaps just now.") + " Try again in a moment.</p>";
    }
  }

  out.addEventListener("click", function (e) {
    if (!model) return;
    var card = e.target.closest("[data-card]");
    if (card) { e.preventDefault(); KD.cardx.openLazy({ name: card.getAttribute("data-card") }, {}); return; }
    if (e.target.closest("[data-unlock]")) { panel.stashForSignIn("/mtg-budget-swaps", { kraken_pending_swaps_autorun: "1" }); KD.ga("swaps_unlock"); return; }
    if (e.target.closest("[data-find]")) { findSwaps(); return; }
    if (e.target.closest("[data-copy-budget]")) { KD.copy(budgetText(), "Budget list copied."); KD.ga("swaps_copy_budget"); return; }
    if (e.target.closest("[data-save-budget]")) {
      try {
        localStorage.setItem("ktm_pending_import", JSON.stringify({ name: (model.commanders[0] ? model.commanders[0].split(",")[0] + " " : "") + "budget deck", format: model.format === "commander" ? "commander" : "standard", list: budgetText(), at: Date.now(), from: "budget-swaps" }));
      } catch (err) { KD.toast("Your browser blocked storage, so copy the list and import it in the dashboard.", "err"); return; }
      KD.ga("swaps_save_budget", { signed_in: KD.signedIn });
      location.href = KD.signedIn ? "/dashboard" : "https://krakenthemeta.com/sign-in";
      return;
    }
    var buy = e.target.closest("[data-buy-budget]");
    if (buy) {
      var rows = budgetRows().map(function (r) { return { name: r.name, qty: r.quantity }; });
      buy.href = window.KTM_AFF && window.KTM_AFF.deckLink ? window.KTM_AFF.deckLink(rows, "magic")
        : "https://www.tcgplayer.com/massentry?productline=Magic&c=" + encodeURIComponent(rows.map(function (r) { return r.qty + " " + r.name; }).join("||"));
      KD.ga("swaps_buy_budget", { transport_type: "beacon" });
      return; // the link opens in a new tab
    }
    if (e.target.closest("[data-analyze]")) { panel.handoff("kraken_pending_analysis", "/mtg-deck-analyzer"); return; }
    if (e.target.closest("[data-odds]")) panel.handoff("kraken_pending_odds", "/mtg-odds");
  });
  out.addEventListener("change", function (e) {
    var r = e.target.closest("[data-pick]");
    if (!r || !swaps) return;
    pick[+r.getAttribute("data-pick")] = parseInt(r.value, 10);
    repaintSwaps();
  });
})();
